<template>
    <div>
        <Panel
            :title="$t('Announcements')"
            :add-button="$t('Add Announcement')"
            :delete-button="selected.length > 0"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="announcements_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Name') }}</th>
                        <th>{{ $t('Start Date') }}</th>
                        <th>{{ $t('End Date') }}</th>
                        <th>{{ $t('Acknowledged Users') }}</th>
                        <th class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="announcement in items" @click="(evt) => handleOpen(announcement.announcementId, evt)">
                        <td class="primary">
                            {{ announcement.name }}
                        </td>
                        <td>{{ announcement.start.format('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td>{{ announcement.end.format('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td style="display: flex; justify-content: left">
                            <div>{{ `${announcement.acknowledgedUsers}/${announcement.totalUsers}` }}</div>
                            <icon-button icon="download-icon" @click="downloadUsers(announcement.announcementId)" />
                        </td>
                        <td>
                            <cic-checkbox
                                :value="selected.includes(announcement.announcementId)"
                                @click="handleSelected(announcement.announcementId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <edit-announcement
            v-if="item !== null"
            v-show="!$store.showLoadingOverlay"
            :item="item"
            :organisations="organisations"
            :users="users"
            @blur="closePopup"
            @input="saveAnnouncement"
            @updateFieldValue="updateFieldValue"
        />
        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import IconButton from '@/components/controls/IconButton';
    import TableUtils from '@/mixins/TableUtils';
    import { save, load, deleteItems } from '@/utils/Http';
    import EditAnnouncement from './EditAnnouncement';

    export default {
        name: 'Announcements',
        components: {
            CicCheckbox,
            EditAnnouncement,
            IconButton,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                organisations: [],
                selected: [],
                users: [],
            };
        },
        created() {
            this.loadOrganisations();
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('announcements/delete', { announcementIds: this.selected }, this.loadTable);
            },

            downloadUsers(announcementId) {
                this.$store.exportFile({
                    link: 'announcement/downloadUsers',
                    params: { announcementId: announcementId },
                });
            },

            loadOrganisations() {
                load('organisation/children', {}, (response) => {
                    this.organisations = response.organisations;
                });
            },

            loadTable() {
                this.selected = [];
                this.closePopup();
                load('announcements/get', {}, (response) => {
                    let temp = response.announcements;

                    temp.forEach((x) => {
                        x.start = moment(x.start);
                        x.end = moment(x.end);
                    });

                    this.items = temp;
                });
            },

            loadUsers() {
                if (!this.item.organisations.length) {
                    this.users = [];
                    this.item.users = [];
                } else {
                    load(
                        'organisation/portalusers',
                        {
                            orgIds: JSON.stringify(this.item.organisations.map((x) => x.orgId)),
                        },
                        (response) => {
                            this.users = response.users;
                        },
                    );
                }
            },

            openForm(announcementId) {
                if (announcementId > 0) {
                    this.item = this.items.find((x) => x.announcementId === announcementId);
                    this.loadUsers();
                } else {
                    this.item = {
                        announcementId: null,
                        message: '',
                        name: '',
                        rights: [],
                        users: [],
                        organisations: [],
                        start: moment(),
                        end: moment().add(1, 'month'),
                    };
                }
            },

            saveAnnouncement() {
                let params = {
                    announcementId: this.item.announcementId,
                    message: this.item.message,
                    name: this.item.name,
                    rights: JSON.stringify(this.item.rights),
                    users: JSON.stringify(this.item.users),
                    organisations: JSON.stringify(this.item.organisations),
                    start: this.item.start.utc().format('YYYY-MM-DD HH:mm:ss'),
                    end: this.item.end.utc().format('YYYY-MM-DD HH:mm:ss'),
                };

                save('announcement/update', params, this.loadTable);
            },

            updateFieldValue(field, value) {
                let oldValues = this.item.organisations.length;
                this.item[field] = value;
                if (field === 'organisations' && value.length !== oldValues) {
                    this.loadUsers();
                }
            },
        },
    };
</script>
